import type { TileConfig } from '../config/types';
import Tile from './Tile';

export default function TileGrid({
  tiles,
  userRoles
}: {
  tiles: TileConfig[];
  userRoles: string[];
}) {
  // Visibility filtering per ADR-013 amendment visibility-tiers:
  // - core: framework-internal, never shown
  // - private: requires at least one matching role
  // - public: visible to all authenticated users
  const visibleTiles = tiles.filter((t) => {
    if (t.visibility === 'core') return false;
    if (t.visibility === 'private') {
      const required = t.requiredRoles ?? [];
      if (required.length === 0) return false;
      return required.some((r) => userRoles.includes(r));
    }
    return true;
  });

  if (visibleTiles.length === 0) {
    return <div className="tile-grid-empty">No services available.</div>;
  }

  return (
    <div className="tile-grid">
      {visibleTiles.map((tile) => (
        <Tile key={tile.id} tile={tile} />
      ))}
    </div>
  );
}
